import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { projectStatuses } from '../lib/schema.js';
import { selectCurrentOrganizationId } from './auth.js';
import { selectEntities } from './entities.js';

const RETRIEVE_PROJECT_STATUSES_REQUEST =
  'changesync/projectStatuses/RETRIEVE_PROJECT_STATUSES_REQUEST';
const RETRIEVE_PROJECT_STATUSES_SUCCESS =
  'changesync/projectStatuses/RETRIEVE_PROJECT_STATUSES_SUCCESS';
const RETRIEVE_PROJECT_STATUSES_FAILURE =
  'changesync/projectStatuses/RETRIEVE_PROJECT_STATUSES_FAILURE';
const UPDATE_PROJECT_STATUSES_REQUEST =
  'changesync/projectStatuses/UPDATE_PROJECT_STATUSES_REQUEST';
const UPDATE_PROJECT_STATUSES_SUCCESS =
  'changesync/projectStatuses/UPDATE_PROJECT_STATUSES_SUCCESS';
const UPDATE_PROJECT_STATUSES_FAILURE =
  'changesync/projectStatuses/UPDATE_PROJECT_STATUSES_FAILURE';

const initialState = {
  projectStatusIds: [],
  retrieveProjectStatuses: {
    pending: false,
    success: false,
    error: null,
  },
  retrieveProjectStatus: {
    pending: false,
    success: false,
    error: null,
  },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_PROJECT_STATUSES_REQUEST:
      return {
        ...state,
        retrieveProjectStatuses: {
          ...state.retrieveProjectStatuses,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_PROJECT_STATUSES_SUCCESS:
      return {
        ...state,
        projectStatusIds: action.payload.result,
        retrieveProjectStatuses: {
          ...state.retrieveProjectStatuses,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_PROJECT_STATUSES_FAILURE:
      return {
        ...state,
        retrieveProjectStatuses: {
          ...state.retrieveProjectStatuses,
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

// Action Creators

export const retrieveProjectStatuses = (query) => (dispatch, getState) => {
  const organizationId = selectCurrentOrganizationId(getState());

  const endpoint = `organizations/${organizationId}/project_statuses`;

  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_PROJECT_STATUSES_REQUEST,
        RETRIEVE_PROJECT_STATUSES_SUCCESS,
        RETRIEVE_PROJECT_STATUSES_FAILURE,
      ],
      endpoint,
      method: HTTP_METHODS.GET,
      schema: [projectStatuses],
      query,
    },
  });
};

export const updateProjectStatuses =
  (projectStatuses) => (dispatch, getState) => {
    const organizationId = selectCurrentOrganizationId(getState());

    const endpoint = `organizations/${organizationId}/project_statuses/bulk_update`;
    return dispatch({
      [CALL_API]: {
        types: [
          UPDATE_PROJECT_STATUSES_REQUEST,
          UPDATE_PROJECT_STATUSES_SUCCESS,
          UPDATE_PROJECT_STATUSES_FAILURE,
        ],
        endpoint,
        method: HTTP_METHODS.PUT,
        body: projectStatuses,
      },
    });
  };

const selectProjectStatusesIds = (state) =>
  state.projectStatuses.projectStatusIds;

export const selectProjectStatuses = createSelector(
  selectProjectStatusesIds,
  selectEntities,
  (projectStatusesIds, entities) =>
    denormalize(projectStatusesIds, [projectStatuses], entities).filter(
      (projectStatus) => !projectStatus.archived
    )
);

export const selectProjectStatusesWithArchived = createSelector(
  selectProjectStatusesIds,
  selectEntities,
  (projectStatusesIds, entities) =>
    denormalize(projectStatusesIds, [projectStatuses], entities)
);

export const selectRetrieveStatusesState = (state) =>
  state.projectStatuses.retrieveProjectStatuses;
